import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Button2 } from "../../../components/Typography";
import { InfoCard } from "../InfoCard";
import { IOrder } from "../types";
import { OrderActions } from "../OrderActions";
import styles from "./OrderInfo.module.css";

interface Props {
  order: IOrder;
}

export const OrderInfo: FC<Props> = ({ order }) => {
  const { t } = useTranslation("order");

  const getOrderDetailsItems = useCallback(() => {
    const items: { name: string | string[]; value: string | number }[] = [
      {
        name: [t("datetime")],
        value: `${order.deliveryDate} ${order.deliveryTime}`,
      },
      { name: [t("code")], value: order.displayCode },
      { name: [t("pinCode")], value: order.pinCode },
      { name: [t("priority")], value: order.priority },
    ];
    return items;
  }, [order, t]);

  const getUserDetailsItems = useCallback(() => {
    const items: { name: string | string[]; value: string | number }[] = [
      { name: [t("phone")], value: order.user.phoneNumber },
      { name: [t("name")], value: order.user.name },
      { name: [t("address")], value: order.user.address },
      { name: [t("locale")], value: order.user.locale },
    ];
    return items;
  }, [order, t]);

  return (
    <div className={styles.container}>
      <InfoCard
        title={`${t("id")}: ${order.id}`}
        status={order.status}
        iconType="order"
        noBottomRadius={false}
        actions={<OrderActions order={order} />}
      >
        <div className={styles["details-container"]}>
          {getOrderDetailsItems().map((item) => (
            <div className={styles["details-item"]}>
              <Body2 className={styles["details-title"]}>{item.name}:</Body2>
              <Button2 className={styles["details-value"]}>
                {item.value}
              </Button2>
            </div>
          ))}
        </div>
      </InfoCard>
      <InfoCard title={t("details")} iconType="orderInfo">
        <div className={styles["details-container"]}>
          {getUserDetailsItems().map((item) => (
            <div className={styles["details-item"]}>
              <Body2 className={styles["details-title"]}>{item.name}:</Body2>
              <Button2>{item.value}</Button2>
            </div>
          ))}
        </div>
      </InfoCard>
    </div>
  );
};
